<div class="page">

  <div class="page-header">
    <div>
      <h1>Ads</h1>
      <p>Manage advertisements and promotions</p>
    </div>
    <button class="btn-primary" (click)="goToNew()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
      </svg>
      New Ad
    </button>
  </div>

  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner-lg"></div>
    <p>Loading ads...</p>
  </div>

  <div class="ads-grid" *ngIf="!isLoading">

    <div class="ad-card" *ngFor="let item of adsList" (click)="goToDetail(item.id)">

      <!-- Image Preview -->
      <div class="card-media">
        <ng-container *ngIf="item.images && item.images.length > 0; else noImage">
          <img [src]="item.images[0]" [alt]="item.title_en" class="media-preview" />
        </ng-container>
        <ng-template #noImage>
          <div class="media-placeholder">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
              <polyline points="21 15 16 10 5 21"/>
            </svg>
          </div>
        </ng-template>
        <span class="media-count" *ngIf="item.images && item.images.length > 1">
          +{{ item.images.length - 1 }} more
        </span>
      </div>

      <!-- Card Body -->
      <div class="card-body">
        <div class="card-top">
          <span class="badge" [class.badge-active]="item.is_active" [class.badge-inactive]="!item.is_active">
            {{ item.is_active ? 'Active' : 'Inactive' }}
          </span>
        </div>
        <h3 class="card-title">{{ item.title_en || item.title_ar }}</h3>
        <p class="card-name">{{ item.name_en || item.name_ar }}</p>
        <p class="card-description">{{ item.description_en || item.description_ar }}</p>
        <div class="card-footer">
          <span class="card-phone" *ngIf="item.phone_number">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
            {{ item.phone_number }}
          </span>
        </div>
      </div>

    </div>

    <div class="empty-state" *ngIf="adsList.length === 0">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
        <polyline points="21 15 16 10 5 21"/>
      </svg>
      <p>No ads yet.</p>
      <button class="btn-primary" (click)="goToNew()">Create First Ad</button>
    </div>

  </div>

</div>
